import { Subject } from "rxjs";

const TAG = "Library.store:";

class LibraryStore {
  libraryChanged = new Subject<string>();
  library = {
    type: "",
    active: {},
  };

  libraryItems = [];

  /**
   * Updating library type and cause a chain reaction
   * @param type
   * @return void
   */
  getLibraryType() {
    return this.library.type;
  }

  setLibraryType(type) {
    /* */
    if (this.library["type"] !== type) {
      this.libraryItems = [];
    }
    this.library["type"] = type;

    this.libraryChanged.next(type);
  }

  /**
   *
   * @param items
   */
  setLibraryItems(items) {
    this.libraryItems = items;
  }

  updateItem(item) {
    console.log("Updating item: ", item);
  }
}

export default new LibraryStore();
